import { useInfiniteQuery, InfiniteData } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

interface AssetRow {
  asset_id: number;
  asset_description: string;
  [key: string]: any;
}

interface AssetsResponse {
  data: {
    rows: AssetRow[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      total_pages: number;
      has_next: boolean;
      has_previous: boolean;
    };
  };
}

type QueryKey = ["project-asset-infinite", string | undefined, string];

export const useInfiniteAssets = (projectId: string | undefined, search: string = "") => {
  const query = useInfiniteQuery<
    AssetsResponse,
    Error,
    InfiniteData<AssetsResponse>,
    QueryKey,
    number
  >({
    queryKey: ["project-asset-infinite", projectId, search],

    queryFn: async ({ pageParam = 1 }) => {
      return projectDetailsApi.fetchProjectAssets(projectId, pageParam, 100, search);
    },

    initialPageParam: 1,

    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (!pagination) return undefined;
      return pagination.page < pagination.total_pages ? pagination.page + 1 : undefined;
    },

    enabled: !!projectId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });

  const assets = query.data?.pages.flatMap((page) => page.data?.rows || []) ?? [];
  const totalAssets = query.data?.pages[0]?.data?.pagination?.total ?? 0;

  return {
    ...query,
    assets,
    totalAssets,
  };
};
